import Drawer from 'components/Drawer'
import React, { useEffect, useState } from 'react'
import Button from '../../../../../components/Button'
import Checkbox from '../../../../../components/Form/Checkbox'
import TreeFilter from '../../../../../components/TreeSelectFilter'
import { FilterSection } from './Partials/GroupCollegeDrawer/style/style'
import { CollegeChart } from './Partials/GroupCreation/Partials/Chart'
import { Map } from './Partials/GroupCreation/Partials/Map'
import { GroupTable } from './Partials/GroupCreation/Partials/Table'

const SelectedCollegesDrawer = ({
  open,
  onClose,
  selectedColleges,
  pageNum = 1,
  pageLimit = 10,
  setSelectedInstitute,
  selectedInstitute = [],
  onRemoveInstitutes,
  setTableLoading,
  handleEditTier,
  handleEditPOC,
  totalItems = 0,
  onPageChange,
  tableLoading = false,
  mode = 'default',
  groupsInstituteCampusIds = [],
  addToGroupColleges = [],
  addToGroupPageNum = 1,
  addToGroupPageLimit = 10,
  addToGroupTotalItems = 0,
  addToGroupLoading = false,
  addToGroupSelectedColleges = [],
  setAddToGroupSelectedIds = () => {},
  setAddToGroupSelectedData = () => {},
  addToGroupSelectedCollegeIds = [],
  setAddToGroupSelectedCollegeIds = () => {},
  onAddToGroupDrawerPageChange = () => {},
  onViewSelectedColleges = () => {},
  filterData = { states: [], cities: [] },
  selectedCollegeFilters = {
    selectedTiers: [],
    selectedStates: [],
    selectedCities: [],
    pilRecommended: false,
    search: '',
  },
  addToGroupSelectedData,
  setSelectedCollegeFilters = () => {},
  selectedDrawerFilterData,
  onFilterChange = () => {},
  chartMetrics,
  mapMetrics,
  // Add these props for dropdown search/filter
  stateOptions = [],
  cityOptions = [],
  onStateSearch,
  onCitySearch,
  onStateDropdownClose,
  onCityDropdownClose,
  handleUpdateInstituteDetails,
  editingRecord,
  handleSort,
}) => {
  console.log(mode,'mode',selectedInstitute,addToGroupSelectedCollegeIds)
  const [filterAdded, setFilterAdded] = useState(false)
  const [lastChangedKey, setLastChangedKey] = useState(null)
  const [searchValue,setSearchValue] = useState('')
  // Handler to update filter state for a given key
  const handleFilterChange = (val, key) => {
    console.log(val,key,'val,key')
    setFilterAdded(true)
    setLastChangedKey(key)
    setSelectedCollegeFilters({
      ...selectedCollegeFilters,
      [key]: val,
    })
  }
  // Trigger parent fetch; debounce only when the last change is 'search'
  useEffect(() => {
    if (!filterAdded) return
    let timer
    if (lastChangedKey === 'search') {
      timer = setTimeout(() => {
        onFilterChange()
        setFilterAdded(false)
      }, 500)
    } else {
      onFilterChange()
      setFilterAdded(false)
    }
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [selectedCollegeFilters, mode, filterAdded, lastChangedKey])
  const handleGroupTablePageChange = page => {
    if (mode === 'addToGroup') {
      onAddToGroupDrawerPageChange(page, addToGroupPageLimit)
    } else {
      if (onPageChange) onPageChange(page, pageLimit)
    }
  }
  // Local tier search and dropdown close logic
  const defaultTierData = [
    { id: '1', name: 'Tier 1', value: 1 },
    { id: '2', name: 'Tier 2', value: 2 },
    { id: '3', name: 'Tier 3', value: 3 },
    { id: '4', name: 'Tier 4', value: 4 },
  ]
  const [tierOptions, setTierOptions] = useState(defaultTierData)
  const handleTierSearch = searchText => {
    if (!searchText) setTierOptions(defaultTierData)
    else
      setTierOptions(
        defaultTierData.filter(t =>
          t.name.toLowerCase().includes(searchText.toLowerCase())
        )
      )
  }
  const handleTierDropdownClose = () => setTierOptions(defaultTierData)

  const content = () => {
    return (
      <>
        <FilterSection>
          <Checkbox
            label="Show only PIL Recc."
            checked={!!selectedCollegeFilters.pilRecommended}
            onChange={e =>
              handleFilterChange(e.target.checked, 'pilRecommended')
            }
            style={{ color: '#000000', fontWeight: 500 }}
          />

          {/* State Filter */}
          <TreeFilter
            treeData={stateOptions.map(opt => ({
              id: opt.stateId,
              name: opt.state,
              value: opt.state,
              key: opt.state+opt.stateId,
            }))}
            treeLoadedKeys={stateOptions.map(opt => opt.state+opt.stateId)}
            placeholder="Select filter"
            label={'State'}
            span={5}
            value={selectedCollegeFilters.selectedStates}
            onChange={val => handleFilterChange(val, 'selectedStates')}
            valueKey="selectedStates"
            {...(typeof onStateSearch === 'function' && {
              onSearch: onStateSearch,
            })}
            {...(typeof onStateDropdownClose === 'function' && {
              onDropdownClose: onStateDropdownClose,
            })}
          />

          {/* City Filter */}
          <TreeFilter
            treeData={cityOptions.map(opt => ({
              id: opt.cityId,
              name: opt.city,
              value: opt.city,
              key: opt.city+opt.cityId,
            }))}
            treeLoadedKeys={cityOptions.map(opt => opt.city+opt.cityId)}
            label="City"
            placeholder="Select filter"
            span={5}
            value={selectedCollegeFilters.selectedCities}
            onChange={val => handleFilterChange(val, 'selectedCities')}
            valueKey="selectedCities"
            {...(typeof onCitySearch === 'function' && {
              onSearch: onCitySearch,
            })}
            {...(typeof onCityDropdownClose === 'function' && {
              onDropdownClose: onCityDropdownClose,
            })}
          />

          {/* Tier Filter */}
          <TreeFilter
            treeData={tierOptions}
            label={'Tier Levels'}
            placeholder="Select filter"
            span={5}
            value={selectedCollegeFilters.selectedTiers}
            onChange={val => handleFilterChange(val, 'selectedTiers')}
            valueKey="selectedTiers"
            onSearch={handleTierSearch}
            onDropdownClose={handleTierDropdownClose}
          />
        </FilterSection>
        <div style={{ display: 'flex', height: '100%' }}>
          <div
            style={{
              flex: 1,
            }}
          >
            <GroupTable
              mode={mode}
              groupInstFilterData={selectedCollegeFilters}
              onGroupFilterChange={handleFilterChange}
              instituteCampusList={
                mode === 'addToGroup' ? addToGroupColleges : selectedColleges
              }
              pageLimit={
                mode === 'addToGroup' ? addToGroupPageLimit : pageLimit
              }
              pageNum={mode === 'addToGroup' ? addToGroupPageNum : pageNum}
              setPageNum={handleGroupTablePageChange}
              setSelectedInstitute={
                mode === 'addToGroup'
                  ? setAddToGroupSelectedIds
                  : setSelectedInstitute
              }
              selectedInstituteData={addToGroupSelectedData}
              setSelectedInstituteData={
                mode === 'addToGroup' ? setAddToGroupSelectedData : ''
              }
              selectedInstitute={
                mode === 'addToGroup'
                  ? addToGroupSelectedCollegeIds
                  : selectedInstitute
              }
              onRemoveInstitutes={onRemoveInstitutes}
              setTableLoading={setTableLoading}
              tableLoading={
                mode === 'addToGroup' ? addToGroupLoading : tableLoading
              }
              handleEditTier={handleEditTier}
              handleEditPOC={handleEditPOC}
              totalItems={
                mode === 'addToGroup' ? addToGroupTotalItems : totalItems
              }
              groupsInstituteCampusIds={groupsInstituteCampusIds}
              onPageChange={onPageChange}
              handleUpdateInstituteDetails={handleUpdateInstituteDetails}
              editingRecord={editingRecord}
              handleSort={handleSort}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Map mapMetrics={mapMetrics} />
            <div style={{ marginTop: 32 }}>
              <CollegeChart chartMetrics={chartMetrics} />
            </div>
          </div>
        </div>
      </>
    )
  }

  const footer = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
        <Button.Secondary text="Cancel" onClick={onClose} />
        {mode === 'addToGroup' && (
          <button
            style={{
              border: 'none',
              background: 'none',
              padding: 0,
              marginLeft: 8,
              cursor: addToGroupSelectedCollegeIds?.length
                ? 'pointer'
                : 'not-allowed', // cursor feedback
              display: 'flex',
              alignItems: 'center',
              opacity: addToGroupSelectedCollegeIds?.length ? 1 : 0.5, // dim when disabled
            }}
            onClick={() =>
            {
              setSelectedCollegeFilters({
                selectedTiers: [],
                selectedStates: [],
                selectedCities: [],
                pilRecommended: false,
                search: '',
              }),
              onRemoveInstitutes(false, addToGroupSelectedCollegeIds)
             
              }
            }
            disabled={!addToGroupSelectedCollegeIds?.length} // disable button
          >
            {/* SVG Button */}
            <svg
              width="135"
              height="42"
              viewBox="0 0 135 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_496_9377)">
                <rect
                  x="2"
                  y="1"
                  width="131"
                  height="38"
                  rx="10"
                  fill="#3249D7"
                />
                <text
                  x="50%"
                  y="50%"
                  dominantBaseline="middle"
                  textAnchor="middle"
                  fill="white"
                  fontSize="14"
                  fontWeight="600"
                >
                  Add to Group
                </text>
              </g>
              <defs>
                <filter
                  id="filter0_d_496_9377"
                  x="0"
                  y="0"
                  width="135"
                  height="42"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="1" />
                  <feGaussianBlur stdDeviation="1" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_496_9377"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_496_9377"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>
        )}
      </div>
    )
  }
  return (
    <Drawer
      zIndex={6000}
      visible={open}
      onClose={onClose}
      title="Selected Colleges"
      footer={footer()}
      content={content()}
      width="80%"
      placement="right"
      closable={true}
    />
  )
}

export default SelectedCollegesDrawer
